import React, { useEffect, useRef, useState } from "react";
import { fetchreviewlist } from "../services/Homereviewlist";
import { API_BASE } from "../api/apiConfig";

const Homereviewlist = () => {
  const [meetups, setMeetups] = useState([]);
  const [activeCountry, setActiveCountry] = useState("All");
  const [activeCity, setActiveCity] = useState("All");
  const sliderRef = useRef(null);

  useEffect(() => {
  const loadData = async () => {
    const res = await fetchreviewlist(); // ✅ correct function
    if (res?.status && Array.isArray(res.data)) {
      setMeetups(res.data);
    }
  };
  loadData();
}, []);



  return (
    <section className="relative w-full bg-gradient-to-b from-slate-50 to-white py-12 md:py-20">
      <div className="absolute left-10 top-20 h-72 w-72 rounded-full bg-teal-400/10 blur-3xl" />
      <div className="absolute right-10 bottom-20 h-72 w-72 rounded-full bg-blue-400/10 blur-3xl" />
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-10 md:mb-14 text-center">
          <div className="transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 mb-4 inline-flex items-center rounded-full bg-teal-500/10 px-4 py-1.5 text-sm font-medium text-teal-600 border-0">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-heart mr-1.5 h-4 w-4 fill-current"
            >
              <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
            </svg>
            Traveler Stories
          </div>
          <h2 className="mb-3 text-3xl md:text-4xl font-bold tracking-tight text-slate-900">
            What Our{" "}
            <span className="bg-gradient-to-r from-teal-500 to-blue-600 bg-clip-text text-transparent">
              Travelers
            </span>{" "}
            Say
          </h2>
          <p className="text-slate-600 text-base md:text-lg max-w-2xl mx-auto">
            Real experiences from real trips. See what makes our community special.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          
      {meetups.map((item) => {
  const expert = item.local_experts_details?.[0]; // ✅ yaha define karo

  return (
          <div key={item.id} className="text-card-foreground group overflow-hidden border-0 shadow-lg hover:shadow-2xl transition-all duration-500 rounded-2xl bg-white">
            <div className="relative h-48 md:h-56 overflow-hidden">
              <img
                alt={item.title}
                loading="lazy"
                decoding="async"
                data-nimg="fill"
                className="object-cover transition-transform duration-700 group-hover:scale-110"
                style={{
                  position: "absolute",
                  height: "100%",
                  width: "100%",
                  inset: 0,
                  color: "transparent"
                }}
                src={`${API_BASE}/${item.image}`}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
              <div className="absolute top-3 right-3 flex items-center gap-2">
                <div className="inline-flex items-center rounded-full px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 bg-white/90 text-slate-800 backdrop-blur-sm border-0 text-xs">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-star mr-1 h-3 w-3 fill-yellow-400 text-yellow-400"
                  >
                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                  </svg>
                  {item.review}
                </div>
              </div>
              <div className="absolute bottom-3 left-3 right-3">
                <h3 className="text-white font-bold text-lg mb-1">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3 text-white/90 text-xs">
                  <div className="flex items-center gap-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-map-pin h-3 w-3"
                    >
                      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                      <circle cx={12} cy={10} r={3} />
                    </svg>
                    <span>{item.city}</span>
                  </div>
                  {/*<div className="flex items-center gap-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-calendar h-3 w-3"
                    >
                      <rect width={18} height={18} x={3} y={4} rx={2} ry={2} />
                      <line x1={16} x2={16} y1={2} y2={6} />
                      <line x1={8} x2={8} y1={2} y2={6} />
                      <line x1={3} x2={21} y1={10} y2={10} />
                    </svg>
                    <span>February 2024</span>
                  </div>*/}
                </div>
              </div>
            </div>
            <div className="p-5">
              <p className="text-slate-700 text-sm leading-relaxed mb-4 italic">
                {item.comment}
              </p>

        {expert && (
              <div className="flex items-center gap-3 pt-4 border-t border-slate-100">
                <div className="relative h-11 w-11 overflow-hidden rounded-full border-2 border-teal-500/20">
                  <img
                    alt={expert.name}
                    loading="lazy"
                    decoding="async"
                    data-nimg="fill"
                    className="object-cover"
                    style={{
                      position: "absolute",
                      height: "100%",
                      width: "100%",
                      inset: 0,
                      color: "transparent"
                    }}
                    src={
                      expert.profileImage
                        ? `${API_BASE}/${expert.profileImage}`
                        : `${API_BASE}/default.jpg`
                    }
                    onError={(e) =>
                      (e.currentTarget.src = `${API_BASE}/default.jpg`)
                    }
                  />
                </div>
                <div className="flex-1">
                  <h4 className="text-sm font-semibold text-slate-900">
                    {expert.name}
                  </h4>
                  <p className="text-xs text-slate-500">{expert.city}</p>
                </div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-chevron-right h-5 w-5 text-teal-500 transition-transform duration-300 "
                >
                  <path d="m9 18 6-6-6-6" />
                </svg>
              </div>
            )}

            </div>
          </div>
      );
      })}


        </div>
        <div className="mt-12 md:mt-16 text-center">
          <div className="inline-flex flex-col items-center gap-4 p-8 rounded-2xl bg-gradient-to-r from-teal-500 to-blue-600">
            <h3 className="text-white text-2xl font-bold">
              Ready to Create Your Own Story?
            </h3>
            <p className="text-white/90 max-w-md">
              Join thousands of travelers exploring India together
            </p>
            <button className="inline-flex items-center justify-center whitespace-nowrap text-sm ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-11 rounded-md px-8 bg-white text-teal-600 hover:bg-white/90 font-semibold">
              Browse Upcoming Trips
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-chevron-right ml-2 h-4 w-4"
              >
                <path d="m9 18 6-6-6-6" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Homereviewlist;
